import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { Unmasked } from '@apollo/client/masking';
import {
  PopularRequestsList,
  PopularRequestsSection,
  Title,
  Chip
} from './styled';
import { getKeywordsByPath } from '../../api/queries';
import { KeywordsByPathQuery } from '../../graphql/graphql';
import { Language } from '../../utils/types';

interface PopularRequestsProps {
  path?: string;
}

export const PopularRequests: React.FC<PopularRequestsProps> = ({
  path = '/'
}) => {
  const { t, i18n } = useTranslation();
  const { data } = useQuery<Unmasked<KeywordsByPathQuery>>(getKeywordsByPath, {
    variables: { path },
    skip: i18n.language === Language.ru
  });

  const keywords = data?.keywords || [];

  const hasKeywords = !!keywords.length && i18n.language !== Language.ru;

  if (!hasKeywords) {
    return null;
  }

  return (
    <PopularRequestsSection data-cy="popular-requests-section">
      <Title data-cy="popular-requests-section-title">
        {t('sections.popular_requests.title')}
      </Title>
      <PopularRequestsList>
        {keywords.map(({ id, term, url }) => (
          <Chip key={id} data-cy="popular-requests-chip">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={url ?? undefined}
            >
              {term}
            </a>
          </Chip>
        ))}
      </PopularRequestsList>
    </PopularRequestsSection>
  );
};
